(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brg-dashboard-instructions"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('brg-dashboard-guide'))customElements.define('brg-dashboard-guide',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const params=new URLSearchParams(window.location.search);const screen=params.get('screen');const software=params.get('dashboard');if(['round','four','five'].includes(screen)){this.querySelector(`[data-screen][value="${screen}"]`).checked=true}if(['lovely','ferrari'].includes(software)){this.querySelector(`[data-software][value="${software}"]`).checked=true}this.addEventListener('change',event=>{if(event.target.matches('[data-screen],[data-software]'))this.show()});this.addEventListener('click',async event=>{const button=event.target.closest('[data-copy-brg-code]');if(!button)return;try{await navigator.clipboard.writeText('BRG20');button.textContent='BRG20 ✓';setTimeout(()=>{button.textContent='BRG20'},1800)}catch(error){const range=document.createRange();range.selectNodeContents(button);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range)}});this.show()}
show(){const screen=this.querySelector('[data-screen]:checked').value;const software=this.querySelector('[data-software]:checked').value;const key=screen==='five'?'five_'+software:screen;this.querySelector('[data-software-choices]').hidden=screen!=='five';this.querySelectorAll('[data-dashboard-panel]').forEach(panel=>{panel.hidden=panel.dataset.dashboardPanel!==key})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brg-display-instructions"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('brg-display-guide'))customElements.define('brg-display-guide',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const device=new URLSearchParams(window.location.search).get('device');if(['racelogic','lumirank'].includes(device))this.querySelector(`[data-device][value="${device}"]`).checked=true;this.addEventListener('change',event=>{if(event.target.matches('[data-device]'))this.show()});this.addEventListener('click',async event=>{const button=event.target.closest('[data-copy-brg-code]');if(!button)return;try{await navigator.clipboard.writeText('BRG20');button.textContent='BRG20 ✓';setTimeout(()=>{button.textContent='BRG20'},1800)}catch(error){const range=document.createRange();range.selectNodeContents(button);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range)}});this.show()}
show(){const key=this.querySelector('[data-device]:checked').value;this.querySelectorAll('[data-device-panel]').forEach(panel=>{panel.hidden=panel.dataset.devicePanel!==key})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brg-installation-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('brg-installation-guide'))customElements.define('brg-installation-guide',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.panels=[...this.querySelectorAll('[data-brg-guide-panel]')];this.addEventListener('change',e=>{if(e.target.matches('input[type="radio"]'))this.show(e.target.value)});const checked=this.querySelector('input[type="radio"]:checked');if(checked)this.show(checked.value)}
 show(id){this.panels.forEach(panel=>{const active=panel.id===id;panel.hidden=!active;const frame=panel.querySelector('iframe[data-brg-guide-video]');if(frame){if(active&&!frame.hasAttribute('src'))frame.src=frame.dataset.brgGuideVideo;else if(!active)frame.removeAttribute('src')}})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brg-revlights-instructions"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('brg-revlights-guide'))customElements.define('brg-revlights-guide',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const setup=new URLSearchParams(window.location.search).get('setup');if(['led16','led8_8','led8_16_8'].includes(setup))this.querySelector(`[data-led-setup][value="${setup}"]`).checked=true;this.addEventListener('change',event=>{if(event.target.matches('[data-led-setup]'))this.show()});this.addEventListener('click',async event=>{const button=event.target.closest('[data-copy-brg-code]');if(!button)return;try{await navigator.clipboard.writeText('BRG20');button.textContent='BRG20 ✓';setTimeout(()=>{button.textContent='BRG20'},1800)}catch(error){const range=document.createRange();range.selectNodeContents(button);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range)}});this.show()}
show(){const key=this.querySelector('[data-led-setup]:checked').value;this.querySelectorAll('[data-led-panel]').forEach(panel=>{panel.hidden=panel.dataset.ledPanel!==key})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brg-sim-flag-instructions"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('brg-simflag-guide'))customElements.define('brg-simflag-guide',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const setup=new URLSearchParams(window.location.search).get('setup');if(['single','dual','combo','brake'].includes(setup))this.querySelector(`[data-setup-choice][value="${setup}"]`).checked=true;this.addEventListener('click',async event=>{const button=event.target.closest('[data-copy-brg-code]');if(!button)return;try{await navigator.clipboard.writeText('BRG20');button.textContent='BRG20 ✓';setTimeout(()=>{button.textContent='BRG20'},1800)}catch(error){const range=document.createRange();range.selectNodeContents(button);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range)}});this.addEventListener('change',event=>{if(event.target.matches('[data-setup-choice]'))this.show(event.target.value)});const selected=this.querySelector('[data-setup-choice]:checked');if(selected)this.show(selected.value)}
show(key){this.querySelectorAll('[data-setup-panel]').forEach(panel=>{panel.hidden=panel.dataset.setupPanel!==key})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brg-sim-rpm-instructions"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async event=>{const button=event.target.closest('.brg-flag [data-copy-brg-code]');if(!button)return;try{await navigator.clipboard.writeText('BRG20');button.textContent='BRG20 ✓';setTimeout(()=>{button.textContent='BRG20'},1800)}catch(error){const range=document.createRange();range.selectNodeContents(button);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
	super();
}

connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.header1 = document.querySelector('.header-wrapper--under-menu')
	this.header_wrapper = document.querySelector('.header-wrapper');
	this.header__offcanvas_menu = document.querySelector('.header__offcanvas-menu');
	this.predictiveSearch = this.querySelector('predictive-search');
	this.headerBounds = {};
	this.currentScrollTop = 0;

	this.onScrollHandler = this.onScroll.bind(this);

	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
}

disconnectedCallback() {
	window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
});

	observer.observe(this.header);
}

onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
		this.predictiveSearch.onFocusOut();
		this.predictiveSearch.onBlur();
	} 
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
	} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
}

	hide() {
		if(this.header1){
			this.header.classList.add('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		}
		else {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}
	// this.closeSearchModal();
}

reveal() {
	if(this.header1){
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-fixed-hidden');
			this.header_wrapper.classList.add('header-wrapper--under-menu-full');
		}
	else {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
	}
	this.header__offcanvas_menu.classList.add('header__offcanvas_menu-reveal')
}

reset() {
	if(this.header1){
		this.header.classList.remove('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		this.header_wrapper.classList.remove('header-wrapper--under-menu-full');
	}
	else {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}
	this.header__offcanvas_menu.classList.remove('header__offcanvas_menu-reveal')

}

closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure?.close());
}

// closeSearchModal() {
// 	this.searchModal = this.searchModal || this.header.querySelector('details-modal');
// 	this.searchModal.close(false);
// }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
	const productRecommendationsSlider = () => {
		$(document).ready(function () {
			$('.js-product-recommendations').each(function (index, parent) {
				let parentId = `#${$(parent).attr('id')}`;

				let carousel = document
					.querySelector(parentId)
					.querySelector(`.js-swiper-product-recommendations`);

				let scrollBar = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-swiper-scrollbar`);

				let prev = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-arrow-prev`);

				let next = document
					.querySelector(parentId)
					.querySelector(`.js-product-recommendations-arrow-next`);

				let swiperCarousel = new Swiper(carousel, {
					slidesPerView: 3,
					spaceBetween: 8,
					scrollbar: {
						el: scrollBar,
						draggable: true,
					},
					navigation: {
						prevEl: prev,
						nextEl: next,
					},
					breakpoints: {
						0: { slidesPerView: 1 },
						920: { slidesPerView: 2 },
						1100: { slidesPerView: 3 },
						1200: { slidesPerView: 2 },
						1300: { slidesPerView: 3 },
						1500: { slidesPerView: 3 },
						1800: { slidesPerView: 3 },
					},
				});

				if (
					$('.js-product-recommendations-arrow-prev').hasClass(
						'swiper-button-lock'
					) ||
					$('.js-product-recommendations-arrow-next').hasClass(
						'swiper-button-lock'
					)
				) {
					$('.nav-tools').css('display', 'none');
				}
			});
		});
	};

	class ProductRecommendations2 extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations2'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
							productRecommendationsSlider();
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations2', ProductRecommendations2);

	document.addEventListener('shopify:section:load', function () {
		productRecommendationsSlider();
	});

  } catch(e) { console.error(e); }
})();
})();
